module.exports = __webpack_public_path__ + "static/media/ic-contact-message.1c7c3948.svg";